import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { useForm } from "@inertiajs/react"
import { usePage } from "@inertiajs/react"
import { FormField } from "@/components/core/form_field"
import { Head } from '@inertiajs/react'

export default function LinkedinComplete({ linkedin_account, className, ...props }) {
  const { data, setData, post, transform, processing, errors } = useForm({
    email: '',
    organization_name: ''
  })

  const { flash } = usePage().props

  const handleSubmit = (event) => {
    event.preventDefault()
    transform(data => ({ registration: data }))
    post('/auth/linkedin_login/registration')
  }

  return (
    <>
      <Head>
        <title>founder/mode | Complete Sign Up</title>
      </Head>
      <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
        <div className="w-full max-w-sm">
          <div className={cn("flex flex-col gap-6 p-6 rounded-lg shadow", className)} {...props}>
            {linkedin_account && (
              <div className="flex flex-col items-center gap-2">
                <div className="relative">
                  {linkedin_account.profile_picture ? (
                    <img
                      src={linkedin_account.profile_picture}
                      alt={linkedin_account.display_name}
                      className="w-16 h-16 rounded-full ring-2 ring-border object-cover"
                    />
                  ) : (
                    <div className="w-16 h-16 rounded-full ring-2 ring-border bg-muted flex items-center justify-center text-xl font-semibold text-muted-foreground">
                      {linkedin_account.display_name?.[0]?.toUpperCase()}
                    </div>
                  )}
                  <span className="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-[#0A66C2]">
                    <svg viewBox="0 0 24 24" className="h-3 w-3 fill-white"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                  </span>
                </div>
                <p className="text-sm font-medium">{linkedin_account.display_name}</p>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="flex flex-col gap-6">
                <div className="flex flex-col items-center gap-2">
                  <h1 className="text-2xl font-semibold tracking-tight">Let's get you set up</h1>
                  <p className="text-center text-sm text-muted-foreground">
                    Enter your email and company name.
                  </p>
                </div>
                <div className="flex flex-col gap-6">
                  <div className="flex flex-col gap-3">
                    <FormField
                      label="Email"
                      name="email"
                      type="email"
                      placeholder="you@example.com"
                      value={data.email}
                      onChange={(e) => setData('email', e.target.value)}
                      errors={errors}
                    />
                    <FormField
                      label="Company Name"
                      name="organization_name"
                      type="text"
                      placeholder="Acme Inc"
                      value={data.organization_name}
                      onChange={(e) => setData('organization_name', e.target.value)}
                      errors={errors}
                    />

                    {flash?.alert && (
                      <p className="text-[0.8rem] mt-1 font-medium text-destructive">{flash.alert}</p>
                    )}
                  </div>
                  <Button type="submit" className="w-full" disabled={processing}>
                    Create Account
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
